import React from "react";
import { NavLink } from "react-router-dom";
import { Col, Grid, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import BootstrapTable from "react-bootstrap-table-next";
import Card from "../../Cards/Card";
import { Tooltip } from "../../Utils/Tooltips";
import { Next } from "../../Icons/Icons";
import { dateFormatter } from "../../Utils/Formatter";

export const RegulatoryEventsContent = ({ data }) => {
  const { t } = useTranslation();

  const regulatoryEvents = data?.regulatorySubmissions ?? [];

  const columns = [
    {
      dataField: "name",
      text: t("regulatorySubmissions.list.nameLabel"),
      formatter: function (cell, row, rowIndex) {
        return <div key={rowIndex}>{`#${row.id} ${row.name}`}</div>;
      },
    },
    {
      dataField: "date",
      text: t("regulatorySubmissions.list.dateLabel"),
      formatter: function (cell) {
        return <div>{dateFormatter(cell, "DD/MMM/YYYY HH:mm")}</div>;
      },
    },
    {
      dataField: "patientName",
      text: t("regulatorySubmissions.list.patientLabel"),
    },
    { dataField: "status", text: t("regulatorySubmissions.list.statusLabel") },
    {
      dataField: "view",
      text: "",
      isDummyField: true,
      headerClasses: "header-protocol-actions",
      classes: "row-protocol-actions",
      headerStyle: { width: "100px" },
      headerAlign: "center",
      align: "center",
      formatter: (_cell, row, rowIndex) => (
        <div key={rowIndex}>
          <Tooltip
            tooltip={t("regulatorySubmissions.list.viewMoreTooltip")}
            id={`tooltipvisit-${row.id}`}
          >
            <NavLink
              to={{
                pathname: `/admin/clinicalTrials/regulatory/${row.id}`,
                state: { startup: data },
              }}
              activeClassName="active"
              className="btn-table-actions"
            >
              <Next />
            </NavLink>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <Card
      title={t("regulatorySubmissions.list.title")}
      className="card-expanded-content"
      content={
        <Grid fluid>
          <Row>
            <Col sm={12} className="marginTop">
              <BootstrapTable
                keyField="id"
                hover={false}
                remote={false}
                wrapperClasses="table-responsive"
                data={regulatoryEvents}
                columns={columns}
                bootstrap4
                bordered={false}
                condensed
              />
            </Col>
          </Row>
        </Grid>
      }
    />
  );
};
